'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Snackbar = require('../Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _roddehI18n = require('roddeh-i18n');

var _roddehI18n2 = _interopRequireDefault(_roddehI18n);

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultLocales = {
  ru: {
    values: {
      "Request error": "Ошибка выполнения запроса"
    }
  }
};
var PrismaCmsComponent = (_temp = _class = function (_PureComponent) {
  _inherits(PrismaCmsComponent, _PureComponent);

  function PrismaCmsComponent(props) {
    _classCallCheck(this, PrismaCmsComponent);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.onChangeBind = function (event) {
      return _this.onChange(event);
    };

    _this.onFocusBind = function (event) {
      return _this.onFocus(event);
    };

    _this.closeErrorBind = function (error) {
      return _this.closeError(error);
    };

    var _this$props = _this.props,
        filters = _this$props.filters,
        locales = _this$props.locales; // let locales = {};
    // for (var lang in propLocales) {
    //   let locale = propLocales[lang] || {};
    //   let defaultLocale = defaultLocales[lang];
    //   if (defaultLocale) {
    //     locale.values = {
    //       ...locale.values,
    //       ...defaultLocale.values,
    //     }
    //   }
    //   locales[lang] = this.createLexicon(locale);
    // }
    // global.component = this;

    _this.state = _extends({}, _this.state, {
      locales: {},
      filters: filters,
      errors: []
    });

    _this.initLocales(defaultLocales);

    if (locales) {
      _this.initLocales(locales);
    }

    return _this;
  }

  PrismaCmsComponent.prototype.initLocales = function initLocales(locales) {
    for (var lang in locales) {
      var locale = locales[lang];

      if (locale) {
        this.addLexicon(lang, locale);
      }
    }
  };

  PrismaCmsComponent.prototype.createLexicon = function createLexicon(locale) {
    return _roddehI18n2.default.create(locale);
  };

  PrismaCmsComponent.prototype.addLexicon = function addLexicon(lang, locale) {
    var locales = this.state.locales;

    if (!locales[lang]) {
      locales[lang] = this.createLexicon(locale);
    } else {
      locales[lang].translator.add(locale);
    }

    return locales[lang];
  };

  PrismaCmsComponent.prototype.lexicon = function lexicon(word, options) {
    var _context$lang = this.context.lang,
        lang = _context$lang === undefined ? "en" : _context$lang;
    var locales = this.state.locales;
    return locales && locales[lang] ? locales[lang](word, options) : word;
  };

  PrismaCmsComponent.prototype.query = function query(params) {
    return this.request("query", params);
  };

  PrismaCmsComponent.prototype.mutate = function mutate(params) {
    return this.request("mutate", params); // .then(async r => {
    //   const {
    //     client,
    //   } = this.context;
    //   await client.clearStore();
    //   return r;
    // });
  };

  PrismaCmsComponent.prototype.request = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(method, params) {
      var client, result, error, errors, _ref2, response, _ref3, success, message, responseErrors, other;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.setState({
                loading: true
              });
              client = this.context.client;
              _context.next = 4;
              return client[method](params).catch(function (error) {
                error.message = error.message && error.message.replace(/^GraphQL error: */, '') || "";
                return error;
              });

            case 4:
              result = _context.sent;
              this.setState({
                loading: false
              });
              error = void 0;
              errors = void 0;

              if (result instanceof Error) {
                error = result.message; // throw(result);
              } else {
                _ref2 = result.data || {}, response = _ref2.response;
                _ref3 = response || {}, success = _ref3.success, message = _ref3.message, responseErrors = _ref3.errors, other = _objectWithoutProperties(_ref3, ['success', 'message', 'errors']);
                errors = responseErrors;

                if (success !== undefined) {
                  if (!success) {
                    error = this.lexicon(message || "Request error");
                  }
                }
              }

              this.setState({
                errors: errors
              });

              if (!error) {
                _context.next = 15;
                break;
              }

              this.addError(error);
              throw result;

            case 15:
              this.setState({
                error: null
              });

            case 16:
              return _context.abrupt('return', result);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return request;
  }();

  PrismaCmsComponent.prototype.reloadApiData = function reloadApiData() {
    var loadApiData = this.context.loadApiData;
    return loadApiData();
  };

  PrismaCmsComponent.prototype.renderField = function renderField(field) {
    var errors = this.state.errors;
    var Field = field.type,
        props = field.props;

    var key = props.key,
        name = props.name,
        label = props.label,
        helperText = props.helperText,
        other = _objectWithoutProperties(props, ['key', 'name', 'label', 'helperText']);

    var error = errors ? errors.find(function (n) {
      return n.key === name;
    }) : null; // return field;

    helperText = error ? error.message : helperText;

    if (helperText) {
      helperText = this.lexicon(helperText);
    }

    return _react2.default.createElement(Field, _extends({
      key: key,
      name: name,
      error: error ? true : false,
      helperText: helperText,
      label: label ? this.lexicon(label) : label // onFocus={event => {
      //   const {
      //     errors,
      //   } = this.state;
      //   if (errors) {
      //     const index = errors.findIndex(({ key }) => key === name);
      //     if (index !== -1) {
      //       errors.splice(index, 1);
      //       this.setState({
      //         errors,
      //       });
      //     }
      //   }
      //   return onFocus ? onFocus(event) : false;
      // }}
      ,
      onFocus: this.onFocusBind,
      onChange: this.onChangeBind
    }, other));
  };

  PrismaCmsComponent.prototype.onChange = function onChange(event) {
    var _updateObject;

    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value,
        type = _event$target.type,
        checked = _event$target.checked;

    switch (type) {
      case "boolean":
      case "checkbox":
        value = checked;
        break;

      case "number":
        value = Number(value);
        break;
    }

    this.updateObject((_updateObject = {}, _updateObject[name] = value, _updateObject));
  };

  PrismaCmsComponent.prototype.onFocus = function onFocus(event) {
    var name = event.target.name;

    if (name) {
      this.resetError(name);
    }

    return;
  };

  PrismaCmsComponent.prototype.resetError = function resetError(name) {
    var errors = this.state.errors;

    if (errors) {
      var index = errors.findIndex(function (_ref4) {
        var key = _ref4.key;
        return key === name;
      });

      if (index !== -1) {
        var newErrors = errors.slice(0);
        newErrors.splice(index, 1);
        this.setState({
          errors: newErrors
        });
      }
    }
  };

  PrismaCmsComponent.prototype.updateObject = function updateObject(data) {
    var _dirty = this.state._dirty;
    this.setState({
      _dirty: _extends({}, _dirty, data)
    });
  };

  PrismaCmsComponent.prototype.getHistory = function getHistory() {
    var history = this.context.router.history;
    return history;
  };

  PrismaCmsComponent.prototype.getLocation = function getLocation() {
    var _getHistory = this.getHistory(),
        location = _getHistory.location;

    return location;
  };

  PrismaCmsComponent.prototype.getLocationUri = function getLocationUri() {
    var _getLocation = this.getLocation(),
        pathname = _getLocation.pathname,
        search = _getLocation.search;

    return new _urijs2.default('' + pathname + search);
  };

  PrismaCmsComponent.prototype.getLocationQuery = function getLocationQuery(field) {
    return this.getLocationUri().query(true)[field];
  };

  PrismaCmsComponent.prototype.onFilterFieldChange = function onFilterFieldChange(event) {
    var _setFilters;

    var _event$target2 = event.target,
        name = _event$target2.name,
        value = _event$target2.value;
    this.setFilters((_setFilters = {}, _setFilters[name] = value ? value : undefined, _setFilters));
  };

  PrismaCmsComponent.prototype.setFilters = function setFilters(data) {
    // let uri = this.getLocationUri();
    // let query = uri.query(true);
    // Object.assign(query, {
    //   ...data,
    //   page: undefined,
    // });
    // uri.query(query);
    // const history = this.getHistory();
    // history.push(uri.toString());
    var filters = this.state.filters;
    this.setState({
      filters: _extends({}, filters, data)
    });
  };
  /**
   * Простая проверка выставлены ли фильтры или нет
   */


  PrismaCmsComponent.prototype.hasFilters = function hasFilters() {
    var filters = this.getFilters();
    return Object.keys(filters).length > 0 ? true : false;
  };
  /**
   * Получаем фильтры из адресной строки
   */


  PrismaCmsComponent.prototype.getFilters = function getFilters() {
    var filters = this.state.filters;
    return filters || {};
  };

  PrismaCmsComponent.prototype.addFilterCondition = function addFilterCondition(where, key, value) {
    var _Object$assign;

    return Object.assign(where, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
  };

  PrismaCmsComponent.prototype.cleanFilters = function cleanFilters() {
    // const {
    //   pathname,
    // } = this.getLocation();
    // const history = this.getHistory();
    // history.push(pathname);
    this.setState({
      filters: null
    });
  };

  PrismaCmsComponent.prototype.canEdit = function canEdit() {
    var _ref5 = this.props.data || {},
        object = _ref5.object;

    var _ref6 = object || {},
        objectId = _ref6.id,
        CreatedBy = _ref6.CreatedBy;

    var _ref7 = this.getCurrentUser() || {},
        currentUserId = _ref7.id,
        sudo = _ref7.sudo;

    var _ref8 = CreatedBy || {},
        createdById = _ref8.id;

    if (objectId) {
      if (sudo || createdById && createdById === currentUserId) {
        return true;
      }
    } else {
      return true;
    }

    return false;
  };

  PrismaCmsComponent.prototype.getCurrentUser = function getCurrentUser() {
    var currentUser = this.context.user;
    return currentUser;
  }; // addError(error) {
  //   error = this.lexicon(error || "Request error");
  //   this.setState({
  //     error,
  //   }, () => {
  //     setTimeout(() => {
  //       // Проверка не очень надежная, так как строки не учитывают инстанс,
  //       // но это лучше, чем ничего.
  //       if (error === this.state.error) {
  //         this.setState({
  //           error: null,
  //         });
  //       }
  //     }, 5000);
  //   });
  // }


  PrismaCmsComponent.prototype.addError = function addError(error) {
    var _this2 = this;

    var errorDelay = this.props.errorDelay;

    if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) !== "object") {
      error = {
        message: error
      };
    }

    Object.assign(error, {
      _id: new Date().getTime()
    });
    var oldNotifications = this.state.notifications;
    var notifications = (oldNotifications || []).slice(0);
    notifications.push(error);

    if (errorDelay) {
      setTimeout(function () {
        return _this2.closeError(error);
      }, errorDelay);
    }

    this.setState({
      notifications: notifications
    });
    return error;
  };

  PrismaCmsComponent.prototype.removeError = function removeError(error) {
    var oldNotifications = this.state.notifications;

    if (oldNotifications && oldNotifications.length) {
      var notifications = oldNotifications.slice(0);
      var index = notifications.indexOf(error);

      if (index !== -1) {
        notifications.splice(index, 1);
        this.setState({
          notifications: notifications
        });
      }
    }
  };

  PrismaCmsComponent.prototype.closeError = function closeError(error) {
    var _this3 = this; // let {
    //   errors,
    // } = this.state;


    Object.assign(error, {
      open: false
    }); // console.log("click event 2", error, this.state.notifications);

    this.forceUpdate();
    setTimeout(function () {
      _this3.removeError(error);
    }, 2000);
  };

  PrismaCmsComponent.prototype.renderErrors = function renderErrors() {
    var _this4 = this; // const {
    //   errorDelay,
    // } = this.props;


    var notifications = this.state.notifications;

    if (notifications && notifications.length) {
      // let output = null;
      var errors = notifications.map(function (error, index) {
        var _id = error._id,
            message = error.message,
            _error$open = error.open,
            open = _error$open === undefined ? true : _error$open;

        if (!message) {
          return null;
        }

        return _react2.default.createElement(_Snackbar2.default, {
          key: _id // opened={error ? true : false}
          ,
          opened: open,
          error: error,
          message: _this4.lexicon(message) // close={this.closeErrorBind("error")}
          ,
          close: _this4.closeErrorBind
        }); // return <Snackbar
        //   key={_id}
        //   open={open}
        //   autoHideDuration={errorDelay}
        //   SnackbarContentProps={{
        //   }}
        //   anchorOrigin={{
        //     vertical: "top",
        //     horizontal: "center",
        //   }}
        //   message={<span
        //   // id="snackbar-fab-message-id"
        //   >
        //     {message}
        //   </span>}
        //   action={
        //     <Fragment>
        //       <Button
        //         color="primary"
        //         variant="raised"
        //         size="small"
        //         onClick={event => {
        //           // console.log("click event", event.target);
        //           event.stopPropagation();
        //           this.closeError(error)
        //         }}
        //       >
        //         Отмена
        //     </Button>
        //     </Fragment>
        //   }
        // />
      }); // const {
      //   document,
      // } = global;
      // if (document.createRange) {
      //   output = ReactDOM.createPortal(<Fragment
      //   >
      //     {errors}
      //   </Fragment>, window.document.body);
      // }
      // else {
      //   output = errors;
      // }

      return errors;
    } else {
      return null;
    }
  };

  PrismaCmsComponent.prototype.render = function render(content) {
    var error = this.state.error;
    var children = this.props.children;
    return _react2.default.createElement(_react.Fragment, null, content, children, this.renderErrors());
  };

  return PrismaCmsComponent;
}(_react.PureComponent), _class.contextType = _context3.default, _class.proptTypes = {
  locales: _propTypes2.default.object,
  filters: _propTypes2.default.object,
  errorDelay: _propTypes2.default.number.isRequired
}, _class.defaultProps = {
  // locales: defaultLocales,
  errorDelay: 5000
}, _temp);
exports.default = PrismaCmsComponent;
module.exports = exports['default'];